import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { welcomeImages, welcomeHighlights } from '../../mock';

const Welcome = () => {
  return (
    <section id="welcome" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative order-2 lg:order-1">
          <img src={welcomeImages.main} alt="Caregiver with client" className="rounded-[2rem] object-cover w-full h-[460px] shadow-lg" />
          <img src={welcomeImages.hands} alt="Caring hands" className="absolute -bottom-8 -right-6 w-44 h-44 rounded-2xl object-cover border-8 border-white shadow-xl hidden md:block" />
          <div className="absolute -top-6 -left-6 w-32 h-32 text-brand-blue/15 dots-pattern hidden md:block" />
        </div>

        <div className="order-1 lg:order-2">
          <span className="font-heading font-semibold text-brand-orange text-sm uppercase tracking-[0.15em]">About us</span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-slate-900 mt-3 mb-6">A companion you can count on</h2>
          <p className="font-body text-slate-600 leading-relaxed mb-8">
            Trusted Companion Health Care Limited helps people across Ireland stay safe, comfortable and independent in the place that matters most — their own home. We pair genuinely caring people with the training, structure and reliability families deserve.
          </p>

          <div className="grid sm:grid-cols-2 gap-x-6 gap-y-4 mb-9">
            {welcomeHighlights.map((h) => (
              <div key={h} className="flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-brand-blue-light flex items-center justify-center shrink-0 mt-0.5">
                  <Check className="w-4 h-4 text-brand-blue" />
                </span>
                <span className="font-body text-slate-700 text-[15px]">{h}</span>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-brand-blue font-heading font-semibold hover:gap-3 transition-all duration-300"
          >
            More about us <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
